import React from 'react'

import * as s from './text.module.css'

interface TextProps {
    innerText: string,
    variation: 'heading' | 'title' | 'normal',
    subHeadingText?: string,
}

export const Text: React.FC<TextProps> = ({ innerText, variation, subHeadingText }) => {

    return <div className={s.container}>
        <div className={s[variation]}>
            {innerText}           
        </div>

        {variation === 'heading' && subHeadingText && <span className={s.subHeadingText}>{ subHeadingText }</span>}

        {variation === 'heading' && <span className={s.line} />}
    </div>
}